import { NewEditorStrictTabs } from './NewEditorStrictTabs';

type Props = {
  isTemplateMode: boolean;
};

export const NewEditorPage: React.FC<Props> = ({ isTemplateMode }) => {
  return <NewEditorStrictTabs isTemplateMode={isTemplateMode} />;
};
